import UsStrategyProductInfo from "components/Product-Info-Pages/UsStrategy/UsStrategyProductInfo";

const UsStrategy = () => <UsStrategyProductInfo />;

export default UsStrategy;
